<script setup lang="ts">
  import { useAttrs } from "vue";

  interface Props {
    label?: string;
    required?: boolean;
  }

  const props = withDefaults(defineProps<Props>(), { required: false });

  const attrs = useAttrs();
</script>

<template>
  <div :class="[$style.base, attrs.class]">
    <span v-if="$props.label" :class="$style.label"
      >{{ $props.label }}<span v-if="$props.required" :class="$style.required"> *</span></span
    >
    <slot />
  </div>
</template>

<style lang="scss" module>
  .base {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .label {
    font-size: 0.875rem; //sm
    line-height: 1.25rem; //sm
    font-weight: 500;
  }

  .required {
    color: var(--destructive);
  }
</style>
